export type Severity = 'informational' | 'warning' | 'success' | 'danger';
